export class EtatIdentite {

    eti_id: string;
    eti_libelle: string;
    eti_couleur: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.eti_id         = data['eti_id'] ? data['eti_id'] : null;
        this.eti_libelle    = data['eti_libelle'] ? data['eti_libelle'] : null;
        this.eti_couleur    = data['eti_couleur'] ? data['eti_couleur'] : null;
    }

}
